import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { finalize, map } from 'rxjs';
import { DocumentTypeService as ComponentService } from '../document-type.service';
import { DocumentCategoryService } from '../../document-category/document-category.service';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import {
  DocumentType as objectPayload,
  DocumentTypeAddPayload as objectAddPayload,
  DocumentTypeEditPayload as objectEditPayload,
  DocumentTypeForm as objectForm,
} from '../document-type.interface';

@Component({
  selector: 'app-add-document-type',
  templateUrl: './add-document-type.component.html',
  styleUrls: ['./add-document-type.component.scss'],
})
export class AddDocumentTypeComponent implements OnInit {
  // general error
  errorTitle: string = helper.dialogConfig.headers.errorAtentie;
  errorIcon: string = helper.dialogConfig.icons.error;
  errorType: string = helper.dialogConfig.icons.error;
  helper = helper;

  token!: string;
  isLoading = false;
  form: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    slug: new FormControl('', [Validators.required]),
    categorie_id: new FormControl('', [Validators.required]),
  });

  categories$: any = [];

  defaultParameter: { name: string; id: string } = {
    name: '--Alegeți--',
    id: '-1',
  };

  constructor(
    private dialogRef: MatDialogRef<AddDocumentTypeComponent>,
    private componentService: ComponentService,
    private notificationService: NotificationService,
    private documentCategoryService: DocumentCategoryService,
    private authService: AuthService
  ) {
    this.processToken();
  }

  ngOnInit(): void {
    this.loadDocumentCategories();
  }

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.componentService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const { name, slug, categorie_id } = this.form.value as objectAddPayload;
    const newObject: objectAddPayload = {
      categorie_id,
      name,
      slug,
    };

    this.componentService
      .store(newObject)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res) => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let msg;
          try {
            // try to catch the message from server
            msg = err.error.errors.message[0];
          } catch (error) {
            // controll output message
            msg = helper.dialogConfig.generalMessages.error;
          }
          this.notificationService.warningSwal(
            this.errorTitle,
            msg,
            this.errorIcon
          );
        },
      });
  }

  loadDocumentCategories() {
    this.isLoading = true;
    this.categories$ = this.documentCategoryService.getRecordsList().pipe(
      map((results: any) => [this.defaultParameter, ...results]),
      finalize(() => (this.isLoading = false))
    );
  }
}
